<template>
  <div>
    <v-sheet elevation="2" rounded color="green accent-2" class="mt-3">
      <div>
        <v-col cols="1" md="1" sm="1">
          <v-icon color="blue darken-2" @click="backButton">
            mdi-arrow-left
          </v-icon>
        </v-col>
        <v-row justify="center" align="center">
          <v-col cols="4" md="4" sm="4">
            <p class="text-center text-h6 font-weight-bold">
              <v-avatar size="70" rounded color="green accent-1">
                <v-img
                  v-if="Info.team.WikipediaLogoUrl"
                  :src="Info.team.WikipediaLogoUrl"
                  max-height="55"
                  max-width="55"
                />
              </v-avatar>
              <br />
              {{ Info.team.City }} {{ Info.team.Name }}( {{ Info.team.Key }})
            </p>
          </v-col>
        </v-row>
      </div>

      <!--team view tab starts -->
      <v-tabs v-model="tab" background-color="transparent" color="basil" grow>
        <v-tab> TEAM PLAYERS </v-tab>
        <!-- <v-tab>
          TEAM PROFILE
        </v-tab> -->
        <v-tab> INJURIES &nbsp;({{ Info.team.injuries.length }}) </v-tab>
        <v-tab> UPCOMING GAMES </v-tab>
      </v-tabs>

      <v-tabs-items :value="tab" touchless>
        <!-- //*TEAM PLAYERS -->
        <v-tab-item>
          <team-players :player="Info.team.teamPlayers" :sportId="SportId" />
        </v-tab-item>
        <!--//*  TEAM PLAYERS ends -->

        <!--//*TEAM PROFILE -->
        <!-- <v-tab-item>
          <single-team :profile="Info.team.teamProfile" />
        </v-tab-item> -->
        <!--//*TEAM PROFILE ends-->

        <!--//* INJURIES -->
        <v-tab-item>
          <team-injuries :injuries="Info.team.injuries" :sportId="SportId" />
        </v-tab-item>
        <!--//* INJURIES ends -->

        <!--//* UPCOMING GAMES -->
        <v-tab-item>
          <upcoming-games :upcomingGames="Info.team.upcomingGames" />
        </v-tab-item>
        <!--//*UPCOMING GAMES ends  -->
      </v-tabs-items>
      <!-- team view tab ends -->
    </v-sheet>
  </div>
</template>

<script>
// import { mapState } from 'vuex';
// import SingleTeam from '@/components/Tabs/tabItems/TeamDetails/SingleTeamProfile.vue';
const SingleTeam = () =>
  import("@/components/Tabs/tabItems/TeamDetails/SingleTeamProfile.vue");

// import TeamInjuries from '@/components/Tabs/tabItems/TeamDetails/TeamInjuries.vue';
const TeamInjuries = () =>
  import("@/components/Tabs/tabItems/TeamDetails/TeamInjuries.vue");

// import TeamPlayers from '@/components/Tabs/tabItems/TeamDetails/TeamPlayers.vue';
const TeamPlayers = () =>
  import("@/components/Tabs/tabItems/TeamDetails/TeamPlayers.vue");

// import UpcomingGames from '@/components/Tabs/tabItems/TeamDetails/UpcomingGames.vue';
const UpcomingGames = () =>
  import("@/components/Tabs/tabItems/TeamDetails/UpcomingGames.vue");

export default {
  name: "TeamProfile",
  components: {
    SingleTeam,
    TeamInjuries,
    TeamPlayers,
    UpcomingGames,
  },
  props: ["teamId", "SportId"],
  data() {
    return {
      tab: null,
      Info: [],
    };
  },
  created() {
    this.fetchTeamInfo();
  },
  computed: {
    // ...mapState('MlbModule', ['Info']),
    computedTeamInfo() {
      if (this.SportId == 1) {
        this.Info = this.$store.state.NbaModule.teamInfo;
      } else if (this.SportId == 2) {
        this.Info = this.$store.state.MlbModule.teamInfo;
      } else if (this.SportId == 3) {
        this.Info = this.$store.state.NhlModule.teamInfo;
      } else if (this.SportId == 4) {
        this.Info = this.$store.state.NflModule.teamInfo;
      }
    },
  },
  methods: {
    backButton() {
      this.$router.go(-1);
    },

    fetchTeamInfo() {
      let obj = {
        teamId: this.teamId,
        SportId: this.SportId,
      };

      if (this.SportId == 1) {
        this.$store.dispatch("NbaModule/getTeamDetails", obj).then(() => {
          this.computedTeamInfo;
        });
      } else if (this.SportId == 2) {
        this.$store.dispatch("MlbModule/getTeamDetails", obj).then(() => {
          this.computedTeamInfo;
        });
      } else if (this.SportId == 3) {
        this.$store.dispatch("NhlModule/getTeamDetails", obj).then(() => {
          this.computedTeamInfo;
        });
      } else if (this.SportId == 4) {
        this.$store.dispatch("NflModule/getTeamDetails", obj).then(() => {
          this.computedTeamInfo;
        });
      }
    },
  },
};
</script>

<style scoped>
.logo {
  margin-left: 40%;
}
.basil {
  background-color: #fffbe6 !important;
}
.basil--text {
  color: #356859 !important;
}
</style>
